import { createBrowserHistory } from 'history';
let history;
let exPath = window.location.pathname + window.location.search;

if (typeof document !== 'undefined') {
  history = createBrowserHistory()
}

export default history;
